import ServiceApi from "../services/service.api";
import ServiceStorage from "./../services/service.storage";
const baseServiceUrl = `/api/v1/Home`;


const ApiHome = {
  getInfos: () => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params: { a: 1 } });
  },
  getMenu: (params) => {
    const url = `${baseServiceUrl}/getMenu`;
    return ServiceApi.get(url, params);
  },
  getSupplierDashboard: () => {
    const url = `${baseServiceUrl}/getSupplierDashboard`;
    return ServiceApi.get(url);
  },
};

export default ApiHome;